// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"f76af773","175":"4487b33a","665":"2e5a05e9","872":"14cde73b"}[chunkId] + ".chunk.js";
};